const UNITS = ['o', 'Ko', 'Mo', 'Go']

const formatBytes = bytes => {
  if (!bytes || bytes <= 0)
    return '0 o'
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1)
  const value = bytes / 1024 ** exponent
  return `${value >= 10 ? Math.round(value) : value.toFixed(1)} ${UNITS[exponent]}`
}

export default formatBytes
